export default __webpack_public_path__ + "static/media/fhiTUKmH.66635da0.svg";